export default __webpack_public_path__ + "static/brand-ampm-bg@1x-47d72c75e5cfeeb76deaf62e64c4899d.jpg";